import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import service from '../service';
import type { RegistrationCode } from '../types/registrationCode';
import { inviteCodeQueryKeys } from './useInviteCodes';

type UseInviteCodeParams = {
  id: string;
  enabled?: boolean;
};

export function useInviteCode({
  id,
  enabled = true,
}: UseInviteCodeParams): UseQueryResult<RegistrationCode, Error> {
  return useQuery<RegistrationCode, Error>({
    queryKey: inviteCodeQueryKeys.detail(id),
    enabled: enabled && !!id,
    queryFn: async () => service.getRegistrationCodeById(id),
  });
}
